import React, { useState, useEffect } from "react";
import Switch from "react-switch";
import { get_subscription_details } from "../../../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import moment from "moment";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import isEmpty from "../../../../../store/validation/is-Empty";
import {
  create_and_update_restaurant,
  vendo_session_settings,
} from "../../../../../store/actions/authAction";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

const SessionSettingsAdminReports = (props) => {
  const [state, setState] = useState({
    // customerOverlayPopup: false,
    openErrorModal: false,
    actionButton: false,
    onCasualDiningMaintainOrdering: false,
    onFastFoodMaintainOrdering: false,
    onMultiServiceMaintainOrdering: false,

    restaurantOpenClosed: props?.data?.sessionSettings?.restaurant_open,
    sessionWalkinWaitlist: false,
    sessionReservation: false,
    autoAcceptWalkinWaitlist: false,
    autoAcceptReservation: false,
    walkinWaitlistOrderAhead: false,
    reservationOrderAhead: false,

    orderSettingTakeAway: false,
    orderSettingCurbsideDelivery: false,
    orderSettingDineIn: false,
    orderSettingSkipTheLine: false,
    orderSettingCatering: false,
    orderSettingHomeDelivery: false,

    autoAcceptOrderTakeAway: false,
    autoAcceptOrderCurbsideDelivery: false,
    autoAcceptOrderDineIn: false,
    autoAcceptOrderSkipTheLine: false,
    autoAcceptOrderCatering: false,
    autoAcceptOrderHomeDelivery: false,

    futureReservation: false,
    futureOrders: false,
    futureTakeAway: false,
    futureCurbSide: false,
    futureDinein: false,
    futureSkipTheLine: false,
    futureCatering: false,
    futureHomeDelivery: false,

    liveStreaming: false,
    eventSessionSettings: false,
    eventTicketSession: false,
    eventAutoAcceptSetting: false,
    scan_And_Pay: false,

    hasSetSession: false,
    errors: {},

    session_auto: false,
    timings: "",
    sendTime: "",
    sessionData: {},
    getNewData: 0,
  });

  useEffect(() => {
    setState({
      ...state,
      restaurantOpenClosed: props?.data?.sessionSettings?.restaurant_open,
    });
  }, [props?.data]);

  const [onboarding, setOnboarding] = useState({});
  const dispatch = useDispatch();
  const token = props.auth.user.accessToken;

  const [restaurant, setRestaurantData] = useState({});
  const [loading, setLoading] = useState(false);

  const onChangeSwitch = (e) => {
    setLoading(true);
    if (
      onboarding?.casual_dining_status ||
      onboarding?.fast_food_dining_status ||
      onboarding?.multi_service_business_status
    ) {
      onClickRestaurantOpenClosed(onboarding);
    } else
      dispatch(
        get_subscription_details(
          token,
          props?.data?.vendor_id,
          (successData) => {
            console.log("get_subscription_details");

            dispatch(
              create_and_update_restaurant(
                {
                  vendor_id: props?.data?.vendor_id,
                  strategy: "category",
                  sub_category: ["5f562c9094ac7fdf47ea1d0a"],
                },
                (restaurantData) => {
                  console.log("create_and_update_restaurant");
                  successData.restaurant_id = restaurantData?._id;
                  setOnboarding(successData);
                  setRestaurantData(restaurantData);
                  setStateData(restaurantData);
                  onClickRestaurantOpenClosed(successData);
                }
              )
            );
          }
        )
      );
  };

  const setStateData = (restaurant_e) => {
    console.log(restaurant, onboarding, restaurant_e);
    let originalTime = moment(
      new Date().setHours(
        parseInt(restaurant_e?.sessionSettings?.automat_time?.split(":")[0]) +
          5,
        parseInt(restaurant_e?.sessionSettings?.automat_time?.split(":")[1]) +
          30
      )
    ).format("HH:mm");
    setState({
      ...state,

      session_auto: !isEmpty(
        restaurant_e?.sessionSettings?.run_sessions_automatically
      )
        ? restaurant_e?.sessionSettings?.run_sessions_automatically
        : false,
      timings: !isEmpty(restaurant_e?.sessionSettings?.automat_time)
        ? originalTime
        : "",
      sendTime: restaurant_e?.sessionSettings?.automat_time || "",
      // restaurantOpenClosed:
      //   restaurant_e?.sessionSettings?.restaurant_open || false,
      sessionWalkinWaitlist: !isEmpty(
        restaurant_e?.sessionSettings?.walkin_wait
      )
        ? restaurant_e?.sessionSettings?.walkin_wait
        : false,
      sessionReservation: !isEmpty(restaurant_e?.sessionSettings?.reservations)
        ? restaurant_e?.sessionSettings?.reservations
        : false,
      autoAcceptWalkinWaitlist: !isEmpty(
        restaurant_e?.autoAcceptSetting?.walkin_wait
      )
        ? restaurant_e?.autoAcceptSetting?.walkin_wait
        : false,
      autoAcceptReservation: !isEmpty(
        restaurant_e?.autoAcceptSetting?.reservations
      )
        ? restaurant_e?.autoAcceptSetting?.reservations
        : false,
      walkinWaitlistOrderAhead: !isEmpty(
        restaurant_e?.orderAheadSetting?.walkinWaitlistOrderAhead
      )
        ? restaurant_e?.orderAheadSetting?.walkinWaitlistOrderAhead
        : false,
      reservationOrderAhead: !isEmpty(
        restaurant_e?.orderAheadSetting?.reservationOrderAhead
      )
        ? restaurant_e?.orderAheadSetting?.reservationOrderAhead
        : false,
      onCasualDiningMaintainOrdering: !isEmpty(
        onboarding?.casual_dining_status?.ordering?.maintain_separate_bank
      )
        ? onboarding?.casual_dining_status?.ordering?.maintain_separate_bank
            ?.value
        : false,
      onFastFoodMaintainOrdering: !isEmpty(
        onboarding?.fast_food_dining_status?.ordering?.maintain_separate_bank
      )
        ? onboarding?.fast_food_dining_status?.ordering?.maintain_separate_bank
            ?.value
        : false,
      onMultiServiceMaintainOrdering: !isEmpty(
        onboarding?.multi_service_business_status?.ordering
          ?.maintain_separate_bank?.value
      )
        ? onboarding?.multi_service_business_status?.ordering
            ?.maintain_separate_bank?.value
        : false,

      orderSettingTakeAway: !isEmpty(
        restaurant_e?.orderSessionSettings?.take_away
      )
        ? restaurant_e?.orderSessionSettings?.take_away
        : false,
      orderSettingCurbsideDelivery: !isEmpty(
        restaurant_e?.orderSessionSettings?.curb_side
      )
        ? restaurant_e?.orderSessionSettings?.curb_side
        : false,
      orderSettingDineIn: !isEmpty(
        restaurant_e?.orderSessionSettings?.dine_in_order
      )
        ? restaurant_e?.orderSessionSettings?.dine_in_order
        : false,
      orderSettingSkipTheLine: !isEmpty(
        restaurant_e?.orderSessionSettings?.skip_line
      )
        ? restaurant_e?.orderSessionSettings?.skip_line
        : false,
      orderSettingCatering: !isEmpty(
        restaurant_e?.orderSessionSettings?.catering
      )
        ? restaurant_e?.orderSessionSettings?.catering
        : false,
      orderSettingHomeDelivery: !isEmpty(
        restaurant_e?.orderSessionSettings?.home_delivery
      )
        ? restaurant_e?.orderSessionSettings?.home_delivery
        : false,

      autoAcceptOrderTakeAway: !isEmpty(
        restaurant_e?.orderAutoAcceptSetting?.take_away
      )
        ? restaurant_e?.orderAutoAcceptSetting?.take_away
        : false,
      autoAcceptOrderCurbsideDelivery: !isEmpty(
        restaurant_e?.orderAutoAcceptSetting?.curb_side
      )
        ? restaurant_e?.orderAutoAcceptSetting?.curb_side
        : false,
      autoAcceptOrderDineIn: !isEmpty(
        restaurant_e?.orderAutoAcceptSetting?.dine_in_order
      )
        ? restaurant_e?.orderAutoAcceptSetting?.dine_in_order
        : false,
      autoAcceptOrderSkipTheLine: !isEmpty(
        restaurant_e?.orderAutoAcceptSetting?.skip_line
      )
        ? restaurant_e?.orderAutoAcceptSetting?.skip_line
        : false,
      autoAcceptOrderCatering: !isEmpty(
        restaurant_e?.orderAutoAcceptSetting?.catering
      )
        ? restaurant_e?.orderAutoAcceptSetting?.catering
        : false,
      autoAcceptOrderHomeDelivery: !isEmpty(
        restaurant_e?.orderAutoAcceptSetting?.home_delivery
      )
        ? restaurant_e?.orderAutoAcceptSetting?.home_delivery
        : false,

      eventAutoAcceptSetting: !isEmpty(
        restaurant_e?.eventAutoAcceptSetting?.RSVP
      )
        ? restaurant_e?.eventAutoAcceptSetting?.RSVP
        : false,
      eventSessionSettings: !isEmpty(restaurant_e?.eventSessionSettings?.RSVP)
        ? restaurant_e?.eventSessionSettings?.RSVP
        : false,
      eventTicketSession: !isEmpty(
        restaurant_e?.eventSessionSettings?.TICKET_BOOKING
      )
        ? restaurant_e?.eventSessionSettings?.TICKET_BOOKING
        : false,
      scan_And_Pay: !isEmpty(restaurant_e?.scan_And_Pay)
        ? restaurant_e?.scan_And_Pay
        : false,

      futureReservation: !isEmpty(restaurant_e?.future_activities?.reservation)
        ? restaurant_e?.future_activities?.reservation
        : false,
      futureOrders: !isEmpty(restaurant_e?.future_activities?.order?.value)
        ? restaurant_e?.future_activities?.order?.value
        : false,
      futureTakeAway: !isEmpty(
        restaurant_e?.future_activities?.order?.take_away
      )
        ? restaurant_e?.future_activities?.order?.take_away
        : false,
      futureCurbSide: !isEmpty(
        restaurant_e?.future_activities?.order?.curb_side
      )
        ? restaurant_e?.future_activities?.order?.curb_side
        : false,
      futureDinein: !isEmpty(
        restaurant_e?.future_activities?.order?.dine_in_order
      )
        ? restaurant_e?.future_activities?.order?.dine_in_order
        : false,
      futureSkipTheLine: !isEmpty(
        restaurant_e?.future_activities?.order?.skip_line
      )
        ? restaurant_e?.future_activities?.order?.skip_line
        : false,
      futureCatering: !isEmpty(restaurant_e?.future_activities?.order?.catering)
        ? restaurant_e?.future_activities?.order?.catering
        : false,
      futureHomeDelivery: !isEmpty(
        restaurant_e?.future_activities?.order?.home_delivery
      )
        ? restaurant_e?.future_activities?.order?.home_delivery
        : false,

      liveStreaming: !isEmpty(restaurant_e?.live_streaming?.value)
        ? restaurant_e?.live_streaming?.value
        : false,

      hasSetSession: true,
    });
  };
  console.log(
    "==================> State.restaurantOpenClosed",
    state.restaurantOpenClosed
  );

  const onClickRestaurantOpenClosed = async (e) => {
    console.log(e);
    let casualDiningMaintainBank =
      e?.casual_dining_status?.ordering?.maintain_separate_bank?.value;
    let fastFoodDiningMaintainBank =
      e?.fast_food_dining_status?.ordering?.maintain_separate_bank?.value;
    let multiDiningMaintainBank =
      e?.multi_service_business_status?.ordering?.maintain_separate_bank?.value;
    const formData = {
      id: e?.restaurant_id,
      vendor_id: e?.vendor_id,
      sessionSettings: {
        run_sessions_automatically: state.session_auto,
        automat_time: state?.sendTime || "",
        restaurant_open: state?.restaurantOpenClosed,
        walkin_wait: state?.sessionWalkinWaitlist,
        reservations: state?.sessionReservation,
      },
      autoAcceptSetting: {
        walkin_wait: state?.autoAcceptWalkinWaitlist,
        reservations: state?.autoAcceptReservation,
      },
      orderAheadSetting: {
        walkinWaitlistOrderAhead: state?.walkinWaitlistOrderAhead,
        reservationOrderAhead: state?.reservationOrderAhead,
      },
      orderSessionSettings: {
        take_away: state?.orderSettingTakeAway,
        curb_side: state?.orderSettingCurbsideDelivery,
        dine_in_order: state?.orderSettingDineIn,
        skip_line: state?.orderSettingSkipTheLine,
        catering: state?.orderSettingCatering,
        home_delivery: state?.orderSettingHomeDelivery,
      },
      orderAutoAcceptSetting: {
        take_away: state?.autoAcceptOrderTakeAway,
        curb_side: state?.autoAcceptOrderCurbsideDelivery,
        dine_in_order: state?.autoAcceptOrderDineIn,
        skip_line: state?.autoAcceptOrderSkipTheLine,
        catering: state?.autoAcceptOrderCatering,
        home_delivery: state?.autoAcceptOrderHomeDelivery,
      },
      future_activities: {
        reservation: state?.futureReservation,
        order: {
          value: state?.futureOrders,
          take_away: state?.futureTakeAway,
          curb_side: state?.futureCurbSide,
          dine_in_order: state?.futureDinein,
          skip_line: state?.futureSkipTheLine,
          catering: state?.futureCatering,
          home_delivery: state?.futureHomeDelivery,
        },
      },
      live_streaming: {
        value: state?.liveStreaming,
      },
      eventSessionSettings: {
        RSVP: state?.eventSessionSettings,
        TICKET_BOOKING: state?.eventTicketSession,
      },
      eventAutoAcceptSetting: {
        RSVP: state?.eventAutoAcceptSetting,
      },
      scan_And_Pay: state?.scan_And_Pay,
    };
    if (state.restaurantOpenClosed) {
      await setState({
        ...state,
        restaurantOpenClosed: !state.restaurantOpenClosed,
        sessionWalkinWaitlist: false,
        sessionReservation: false,
        orderSettingTakeAway: false,
        orderSettingCurbsideDelivery: false,
        orderSettingDineIn: false,
        orderSettingSkipTheLine: false,
        orderSettingCatering: false,
        orderSettingHomeDelivery: false,
        actionButton: true,
      });
      formData.sessionSettings.restaurant_open = !state.restaurantOpenClosed;
      formData.sessionSettings.walkin_wait = false;
      formData.sessionSettings.reservations = false;
      formData.orderSessionSettings.take_away = false;
      formData.orderSessionSettings.curb_side = false;
      formData.orderSessionSettings.dine_in_order = false;
      formData.orderSessionSettings.skip_line = false;
      formData.orderSessionSettings.catering = false;
      formData.orderSessionSettings.home_delivery = false;
      formData.autoAcceptSetting.walkin_wait = true;
      formData.autoAcceptSetting.reservations = true;
      formData.future_activities.reservation = true;
      formData.orderAheadSetting.walkinWaitlistOrderAhead = true;
      formData.orderAheadSetting.reservationOrderAhead = true;
      formData.future_activities.order.value = true;
      formData.future_activities.order.take_away = true;
      formData.future_activities.order.curb_side = true;
      formData.future_activities.order.dine_in_order = true;
      formData.future_activities.order.skip_line = true;
      formData.future_activities.order.catering = true;
      formData.future_activities.order.home_delivery = true;
      finalSubmit(formData);
    } else if (
      !casualDiningMaintainBank ||
      !fastFoodDiningMaintainBank ||
      !multiDiningMaintainBank
    ) {
      await setState({
        ...state,
        // openErrorModal: true,
        restaurantOpenClosed: !state.restaurantOpenClosed,
        sessionWalkinWaitlist: true,
        sessionReservation: true,
        orderSettingTakeAway: false,
        orderSettingCurbsideDelivery: false,
        orderSettingDineIn: false,
        orderSettingSkipTheLine: false,
        orderSettingCatering: false,
        orderSettingHomeDelivery: false,
        autoAcceptWalkinWaitlist: true,
        autoAcceptReservation: true,
        walkinWaitlistOrderAhead: true,
        reservationOrderAhead: true,
        autoAcceptOrderTakeAway: false,
        autoAcceptOrderCurbsideDelivery: false,
        autoAcceptOrderDineIn: false,
        autoAcceptOrderSkipTheLine: false,
        autoAcceptOrderCatering: false,
        autoAcceptOrderHomeDelivery: false,
        futureReservation: true,
        futureOrders: true,
        futureTakeAway: true,
        futureCurbSide: true,
        futureDinein: true,
        futureSkipTheLine: true,
        futureCatering: true,
        futureHomeDelivery: true,
        liveStreaming: true,
        eventSessionSettings: true,
        eventTicketSession: true,
        eventAutoAcceptSetting: true,
        scan_And_Pay: true,
        actionButton: true,
      });
      formData.sessionSettings.restaurant_open = !state.restaurantOpenClosed;
      formData.sessionSettings.walkin_wait = true;
      formData.sessionSettings.reservations = true;
      formData.orderSessionSettings.take_away = false;
      formData.orderSessionSettings.curb_side = false;
      formData.orderSessionSettings.dine_in_order = false;
      formData.orderSessionSettings.skip_line = false;
      formData.orderSessionSettings.catering = false;
      formData.orderSessionSettings.home_delivery = false;
      formData.autoAcceptSetting.walkin_wait = true;
      formData.autoAcceptSetting.reservations = true;
      formData.orderAheadSetting.walkinWaitlistOrderAhead = true;
      formData.orderAheadSetting.reservationOrderAhead = true;
      formData.orderAutoAcceptSetting.take_away = false;
      formData.orderAutoAcceptSetting.curb_side = false;
      formData.orderAutoAcceptSetting.dine_in_order = false;
      formData.orderAutoAcceptSetting.skip_line = false;
      formData.orderAutoAcceptSetting.catering = false;
      formData.orderAutoAcceptSetting.home_delivery = false;
      formData.future_activities.reservation = true;
      formData.future_activities.order.value = true;
      formData.future_activities.order.take_away = true;
      formData.future_activities.order.curb_side = true;
      formData.future_activities.order.dine_in_order = true;
      formData.future_activities.order.skip_line = true;
      formData.future_activities.order.catering = true;
      formData.future_activities.order.home_delivery = true;
      formData.live_streaming.value = true;
      formData.eventSessionSettings.RSVP = true;
      formData.eventSessionSettings.TICKET_BOOKING = true;
      formData.eventAutoAcceptSetting.RSVP = true;
      formData.scan_And_Pay = true;
      finalSubmit(formData);
    } else {
      await setState({
        ...state,
        restaurantOpenClosed: !state.restaurantOpenClosed,
        sessionWalkinWaitlist: true,
        sessionReservation: true,
        orderSettingTakeAway: true,
        orderSettingCurbsideDelivery: true,
        orderSettingDineIn: true,
        orderSettingSkipTheLine: true,
        orderSettingCatering: true,
        orderSettingHomeDelivery: true,
        autoAcceptWalkinWaitlist: true,
        autoAcceptReservation: true,
        walkinWaitlistOrderAhead: true,
        reservationOrderAhead: true,
        autoAcceptOrderTakeAway: true,
        autoAcceptOrderCurbsideDelivery: true,
        autoAcceptOrderDineIn: true,
        autoAcceptOrderSkipTheLine: true,
        autoAcceptOrderCatering: true,
        autoAcceptOrderHomeDelivery: true,
        futureReservation: true,
        futureOrders: true,
        futureTakeAway: true,
        futureCurbSide: true,
        futureDinein: true,
        futureSkipTheLine: true,
        futureCatering: true,
        futureHomeDelivery: true,
        liveStreaming: true,
        eventSessionSettings: true,
        eventTicketSession: true,
        eventAutoAcceptSetting: true,
        scan_And_Pay: true,
        actionButton: true,
      });
      formData.sessionSettings.restaurant_open = !state.restaurantOpenClosed;
      formData.sessionSettings.walkin_wait = true;
      formData.sessionSettings.reservations = true;
      formData.orderSessionSettings.take_away = true;
      formData.orderSessionSettings.curb_side = true;
      formData.orderSessionSettings.dine_in_order = true;
      formData.orderSessionSettings.skip_line = true;
      formData.orderSessionSettings.catering = true;
      formData.orderSessionSettings.home_delivery = true;
      formData.autoAcceptSetting.walkin_wait = true;
      formData.autoAcceptSetting.reservations = true;
      formData.orderAheadSetting.walkinWaitlistOrderAhead = true;
      formData.orderAheadSetting.reservationOrderAhead = true;
      formData.orderAutoAcceptSetting.take_away = true;
      formData.orderAutoAcceptSetting.curb_side = true;
      formData.orderAutoAcceptSetting.dine_in_order = true;
      formData.orderAutoAcceptSetting.skip_line = true;
      formData.orderAutoAcceptSetting.catering = true;
      formData.orderAutoAcceptSetting.home_delivery = true;
      formData.future_activities.reservation = true;
      formData.future_activities.order.value = true;
      formData.future_activities.order.take_away = true;
      formData.future_activities.order.curb_side = true;
      formData.future_activities.order.dine_in_order = true;
      formData.future_activities.order.skip_line = true;
      formData.future_activities.order.catering = true;
      formData.future_activities.order.home_delivery = true;
      formData.live_streaming.value = true;
      formData.eventSessionSettings.RSVP = true;
      formData.eventSessionSettings.TICKET_BOOKING = true;
      formData.eventAutoAcceptSetting.RSVP = true;
      formData.scan_And_Pay = true;
      finalSubmit(formData);
    }
  };

  const finalSubmit = (formData) => {
    console.log("------------------finalSubmit------------------", state);

    if (state?.restaurantOpenClosed) {
      dispatch(
        vendo_session_settings(token, "diner", "admin", props?.data?.vendor_id)
      );
      dispatch(
        vendo_session_settings(token, "order", "admin", props?.data?.vendor_id)
      );
      dispatch(
        vendo_session_settings(
          token,
          "event-handler",
          "admin",
          props?.data?.vendor_id
        )
      );
      dispatch(
        create_and_update_restaurant(
          formData,
          (data) => {
            console.log(data, "====================> Success");
          },
          (err) => console.log(err, "====================> Failed")
        )
      );
    } else {
      dispatch(
        create_and_update_restaurant(
          formData,
          (data) => console.log(data, "====================> Success"),
          (err) => console.log(err, "====================> Failed")
        )
      );
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      {loading ? (
        <>
          {" "}
          <Loader type="ThreeDots" color="#ee3a23" height={25} width={25} />
        </>
      ) : (
        <Switch
          onChange={(e) => onChangeSwitch(e)}
          checked={state?.restaurantOpenClosed}
          offColor="#EEEEEE"
          onColor="#EEEEEE"
          offHandleColor="#212121"
          onHandleColor="#59F832"
          handleDiameter={24}
          uncheckedIcon={false}
          checkedIcon={false}
          height={15}
          width={41}
          boxShadow="-2px 0px 5px #0000003B"
          activeBoxShadow="-2px 0px 5px #0000003B"
          id="material-switch"
        />
      )}
    </React.Fragment>
  );
};

SessionSettingsAdminReports.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps)(
  withRouter(SessionSettingsAdminReports)
);
